import { PLATFORM } from 'aurelia-pal';
/**
 * The configuration function Aurelia calls when the library is loaded.
 *
 * It's by design that it only register generic resources, to avoid adding possible unnecessary
 * stuff to the bundle. If the app needs other services/components/containers, it would need to
 * define a custom module/plugin and import them.
 * @param {FrameworkConfiguration} frameworkConfig The object the framework uses to configure
 *                                                 resources.
 */
export const configure = (frameworkConfig) => {
  if (frameworkConfig.globalResources) {
    frameworkConfig.globalResources(
      PLATFORM.moduleName('./customAttributes/classToggle.customAttribute'),
      PLATFORM.moduleName('./valueConverters/listFilter.valueConverter'),
    );
  }
};
